<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-7">
      {{ salyginisTitle }}
    </h3>
    <template v-if="!salyginis && !pageloading">
      <el-button
        primary
        @click.native="gotoHipotekaPranesimas()"
        :disabled="hipotekaReadonly"
        >{{ salyginisButton }} "{{ salyginisLabel }}"</el-button
      >
    </template>
    <template v-if="salyginis">
      <div class="dataContainer">
        <v-row>
          <v-col cols="12">
            <el-radio-group
              inline
              class="my-2"
              :readonly="isReadonlyForm || checkIsigaliojimas"
              :items="salygaTipas"
              v-model="formData.obj_salyginis_tipas"
            />
          </v-col>
          <v-col cols="12">
            <el-textarea
              :label="tekstas.aprasymas"
              :tooltip="tekstas.aprasymasTooltip"
              :readonly="isReadonlyForm || checkIsigaliojimas"
              class="mb-0"
              :counter="2000"
              v-model="formData.obj_salyginis_salyga"
              autofocus
            />
          </v-col>
          <template v-if="showIsigaliojimas">
            <v-col cols="12">
              <el-checkbox
                class="mb-4"
                :readonly="isReadonlyForm"
                :label="tekstas.isigaliojusi"
                :tooltip="tekstas.isigaliojusiTooltip"
                v-model="formData.obj_salyginis_isigaliojusi"
              />
            </v-col>
            <v-col cols="12">
              <el-textarea
                need
                :readonly="isReadonlyForm || !checkIsigaliojimas"
                :label="tekstas.salyga_ivykdyta"
                :tooltip="tekstas.salyga_ivykdytaTooltip"
                :counter="2000"
                v-model="formData.obj_salyginis_salyga_ivykdyta"
              />
            </v-col>
          </template>
        </v-row>
      </div>

      <hipoteka-istorija class="mt-5" duomenys="salyginis" />

      <v-footer class="form-footer">
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="saveData()"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button
          v-if="!isReadonlyForm"
          @click.native="cancelData()"
          :loading="loading"
          >Atšaukti</el-button
        >
        <v-spacer></v-spacer>
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="checkErrorsClick()"
          :loading="loading"
          >Tikrinti</el-button
        >
      </v-footer>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaSalyginis',
  components: {
    HipotekaIstorija,
  },
  mixins: [unsavedData, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      obj_rusys: {},
      palukanos: null,
      kita_informacija: null,
      loading: true,
      pageloading: true,
      isIsigaliojimas: false,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return (
        this.hipotekaReadonly ||
        this.readonlyForm ||
        (this.isIsigaliojimas && false)
      )
    },
    salyginisLabel() {
      const key = Object.keys(HipotekaMap['pranesimasRusis']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['pranesimasRusis'][key].labels.salyginis : null
    },
    salygaTipas() {
      return [
        {
          label: this.tekstas.isigaliojimo_salyga,
          tooltip: this.tekstas.isigaliojimo_salygaTooltip,
          value: 1,
        },
        {
          label: this.tekstas.galiojimo_pabaiga,
          tooltip: this.tekstas.galiojimo_pabaigaTooltip,
          value: 2,
        },
      ]
    },
    tekstas() {
      const key = Object.keys(HipotekaMap['salyginisTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['salyginisTekstas'][key] : {}
    },
    salyginis() {
      return this.obj_rusys.salyginis
    },
    salyginisTitle() {
      return this.tekstas.title
    },
    salyginisButton() {
      return this.tekstas.button
    },
    isPradzia() {
      return (
        this.hipotekaTipas.includes('sandoris') ||
        this.hipotekaTipas.includes('nustatymas') ||
        this.hipotekaTipas.includes('atlikimas') ||
        this.hipotekaTipas.includes('teikimas')
      )
    },
    checkIsigaliojimas() {
      return this.formData.obj_salyginis_isigaliojusi
    },
    showIsigaliojimas() {
      return !this.isPradzia && this.formData.obj_salyginis_tipas === 1
    },
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/salyginis`)
        .then(res => {
          this.formData = res.data.salyginis
          this.obj_rusys = res.data.obj_rusys
          this.isIsigaliojimas = res.data.salyginis.isigaliojusi
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/salyginis`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    gotoHipotekaPranesimas() {
      this.$router.push({
        name: 'hipotekaPranesimas',
        params: {
          objektasID: this.objektasID,
        },
      })
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 850px;
}
</style>
